import { render } from "./gallery-index.vue?vue&type=template&id=08a9d1e2&scoped=true"
import script from "./gallery-index.vue?vue&type=script&lang=js"
export * from "./gallery-index.vue?vue&type=script&lang=js"

import "./gallery-index.vue?vue&type=style&index=0&id=08a9d1e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a9d1e2"]])

export default __exports__